import { render, staticRenderFns } from "./ConsultSection.vue?vue&type=template&id=5dcfe4e5&scoped=true"
import script from "./ConsultSection.vue?vue&type=script&lang=js"
export * from "./ConsultSection.vue?vue&type=script&lang=js"
import style0 from "./ConsultSection.vue?vue&type=style&index=0&id=5dcfe4e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcfe4e5",
  null
  
)

export default component.exports